<template>
  <div class="container">
    <component
      :is="question ? question.type : null"
      v-bind="question ? question.data : null"
      :value="value"
      :expected-response="question ? question.expectedResponse : null"
      @change="handleChange"
    />
  </div>
</template>

<script>
import ResponseComponents from './questions'

/**
 * <!-- Scale -->
    <div class="scale" v-if="question.type === 'scale'">
      <!-- Each "answer" represents a question -->
      <div class="wrapper" v-for="answer in question.answers" :key="answer.label">
        <div class="title">{{ answer.label }}</div>
        <div class="description">{{ answer.description }}</div>
        <vv-scale
          :from="0"
          :to="5"
          :value="getScaleValue(answer.label)"
          @change="value => handleChange(value, answer.label)"
        />
      </div>
 */

export default {
  name: 'TastingAnswer',
  props: {
    question: Object,
    value: String | Number | Array | Object
  },
  components: { ...ResponseComponents },
  methods: {
    /**
     * Notify the parent that the user response changed
     * @param {Object} payload
     * @param {any} payload.value
     * @param {boolean} payload.correct
     */
    handleChange(payload) {
      this.$emit('input', payload.value)
      this.$emit('status', payload.correct)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin-top: 30px;
}

.scale {
  text-align: left;

  .wrapper {
    margin: 15px 0 20px;
    padding: 0 15px;
  }

  .title {
    font-weight: bold;
    margin-bottom: 8px;
  }

  .description {
    margin-bottom: 15px;
  }
}
</style>
